import Desktop from 'pages/Quizzes/desktop';

const Tablet = () => <Desktop device={'tablet'} />;

export default Tablet;
